import { CustomerKycError, refreshCustomerKyc } from './customer-kyc.js';
/** The number comes only from the authenticated backend’s fresh Twilio verification. */
export async function submitVerifiedPhone(client, provider, customerId, signal) {
    const current = await refreshCustomerKyc(provider, customerId);
    if (signal?.aborted)
        throw new Error('onramp_session_disposed');
    if (current.challenge ||
        current.status !== 'collecting' ||
        current.requirements.phoneNumber?.status !== 'incomplete')
        return current;
    const phone = await client.getVerifiedPhone(signal);
    if (signal?.aborted)
        throw new Error('onramp_session_disposed');
    if (!phone)
        throw new CustomerKycError('phone_verification_required');
    const result = await provider.submitCustomerKyc(customerId, {
        phoneNumber: { number: phone.phoneNumber },
    });
    if (signal?.aborted)
        throw new Error('onramp_session_disposed');
    if (!result.ok && result.error.code !== 'conflict')
        throw new CustomerKycError(result.error.code);
    if (result.ok && result.value.data.id !== customerId)
        throw new CustomerKycError('customer_mismatch');
    return refreshCustomerKyc(provider, customerId);
}
